<div [ngClass]="{'superheader': role === 'SuperAdmin'}" class="layout-topbar toogle-text supper-header1" [ngClass]="{'header-hover': isSidebarHovered}">
   <div class="super-text">
      <button #menubutton (click)="toggleSidebar()" class="p-link layout-menu-button layout-topbar-button">
         <em class="pi pi-times" *ngIf="isSmallScreen && isSidebarOpen;else smallSc"></em>
         <ng-template #smallSc>
            <em class="pi pi-bars"></em>
         </ng-template>

      </button>

      <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button">
      </button>
      <div >
         <div  *ngIf="((role === 'ParkingOwner' || 'ParkingManager') && companyLogo) " class="company-logo">
         <img [src]="companyLogo || imagePath" alt="Company logo"/>
         </div>
      </div>
      <h4 *ngIf="breadcrumbText">
         <div class="parking-status custom-stats" [innerHTML]="breadcrumbText" ></div>
      </h4>

   </div>

   <div #topbarmenu class="layout-topbar-menu" outSideClick (outSideClick)="closeNotificationOnOutSideClick()">
      <div *ngIf="showCompanyText" class="super-text text-changes">
         <h4><span class="company-name1">{{companyName}} </span></h4>
         <button class="custom-changes" (click)="openCompanyListModal()" >change</button>
      </div>

      <div *ngIf="!isGuestUser && userName" class="bell-outer">
         <button class="p-link layout-topbar-button">
            <em class="pi pi-bell" (click)="showHideNotificationList()"></em>
         </button>
         <span *ngIf="totalNotifications>0">{{ totalNotifications}}</span>
         <div *ngIf="showNotifications" class="droplist-outer">
            <h3>{{ totalNotifications>0 ?'Notifications':'No notifications'}}</h3>
            <div  class="notification-main" (scroll)="onScroll($event)">
                  <p-progressSpinner *ngIf="isLoading" strokeWidth="6" [style]="{ width: '60px', height: '60px' }"></p-progressSpinner>
               <div class="notification-list" *ngFor="let notify of notificationRecord"
                  (click)="handleNotificationClick(notify)">
                  <div class="user-img">
                     <img
                        [src]="notify.subject !== 'Reservation Limit Reached' ? 'assets/images/notification-user.png' : 'assets/images/full-parking.png'" alt=""/>
                  </div>
                  <div class="user-righttext">
                     <h5>{{ notify.subject }}</h5>
                     <h4>{{ notify.message }}</h4>
                     <p class="time-ago">{{notify.createdTime}}</p>
                  </div>
               </div>
            </div>

         </div>
      </div>
      <div *ngIf="!isGuestUser && userName" class="p-img export-btn">
         <span>{{userName}}</span>
         <a class="drop-nav" (click)="menu.toggle($event);showData()">
            <img [src]="imagePath" alt="Prime Blocks" class="ml-3" width="42px" />
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
               <path d="M7.5 0.125L3.75 3.875L0 0.125001L7.5 0.125Z" fill="#2F3436"/>
               </svg>
         </a>
      </div>

   </div>

</div>
<div class="custom-export"><p-menu #menu [model]="items" [popup]="true"></p-menu></div>
